module.exports = __webpack_public_path__ + "static/media/importFlybook4.4e1b4264.png";